import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import AppContent from "./AppContent";
import ScrollRestorationManager from "./components/ScrollRestorationManager";

const App: React.FC = () => (
  <ThemeProvider>
    <Router>
           <ScrollRestorationManager />
      <AppContent />
    </Router>
  </ThemeProvider>
);

export default App;
